import { render, staticRenderFns } from "./AssistantAi.vue?vue&type=template&id=7bb734a6&scoped=true"
import script from "./AssistantAi.vue?vue&type=script&lang=js"
export * from "./AssistantAi.vue?vue&type=script&lang=js"
import style0 from "./AssistantAi.vue?vue&type=style&index=0&id=7bb734a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb734a6",
  null
  
)

export default component.exports